import { useState, useEffect } from "react";
import { Carousel } from 'react-responsive-carousel';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import useSWR from "swr";
import ReactPaginate from "react-paginate";
import { NumericFormat } from "react-number-format";

const Welcome = () => {
  const { user } = useSelector((state) => state.auth);
  const [store, setStore] = useState([]);
  //const [urlstore, setUrlStore] = useState("");
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keywordname, setKeywordName] = useState("");
  const [queryname, setQueryName] = useState("");
  const [keywordmanu, setKeywordManu] = useState("");
  const [querymanu, setQueryManu] = useState("");
  const [keywordserial, setKeywordSerial] = useState("");
  const [queryserial, setQuerySerial] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  //fetcher data ticket open
  const fetcher_open = async () => {
    const response = await axios.get(`${API_BASE_URL}/ticketopen`);
    return response.data;
  };
  let dataopen;
  const { data: open } = useSWR("opens", fetcher_open);
  if (!open) {
    dataopen = 0;
  }else{
    dataopen=open;
  };

  //fetcher data ticket closed
  const fetcher_close = async () => {
    const response = await axios.get(`${API_BASE_URL}/ticketclose`);
    return response.data;
  };
  let dataclose;
  const { data: close } = useSWR("closed", fetcher_close);
  if (!close) {
    dataclose = 0;
  }else{
    dataclose=close;
  };

  //fetcher data ticket repair
  const fetcher_repair = async () => {
    const response = await axios.get(`${API_BASE_URL}/ticketrepair`);
    return response.data;
  };
  let datarepair;
  const { data: repair } = useSWR("repaired", fetcher_repair);
  if (!repair) {
    datarepair = 0;
  }else{
    datarepair=repair;
  };

    //fetcher data ads
  const fetcher_ads = async () => {
    const response = await axios.get(`${API_BASE_URL}/advertisement`);
    return response.data;
  };
  let dataads;
  const { data: ads } = useSWR("ads", fetcher_ads);
  if (!ads) {
    dataads = null;
  }else{
    dataads = ads;
  };

  useEffect(() => {
      const fetchProducts = async () => {
          try {
              const response = await axios.get(
                `${API_BASE_URL}/homepages?search_name=${keywordname}&search_serial=${keywordserial}&search_manufacture=${keywordmanu}&page=${page}&limit=${limit}`,
                {
                  headers: {
                      'X-API-Key': API_KEY
                  },
                }
              ); 
              setStore(response.data.result);
              setPage(response.data.page);
              setPages(response.data.totalPage);
              setRows(response.data.totalRows);
          } catch (error) {
              console.error('Error fetching products:', error);
          } finally {
              setLoading(false);
          }
      };
  fetchProducts();
  }, [page, keywordname, keywordmanu, keywordserial]);

  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
    setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
    );
    } else {
    setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordName(queryname);
    setKeywordManu(querymanu);
    setKeywordSerial(queryserial);
  };


  if (loading) {
      return <div>Loading...</div>;
  }
  return (
    <div className="container pb-6">
      <div className="columns">
        {user && user.role==="admin" ? (
        <div className="column is-centered">
          <h1 className="title is-size-5">Dashboard</h1>
          <h2 className="subtitle">
            Welcome Back <strong>{user && user.name}</strong>
          </h2>
          <div className="columns mt-5">
              <div className="column is-3">
                  <div className="box has-text-centered has-background-primary">
                    <h1 className="has-text-weight-bold has-text-white">
                      <div><Link className="has-text-white" to="/tickets">{dataopen}</Link></div>
                      <div>New Tickets</div>                        
                    </h1>
                  </div>
              </div>
              <div className="column is-3">
                  <div className="box has-text-centered has-background-danger">
                    <h1 className="has-text-weight-bold has-text-white">
                      <div><Link className="has-text-white" to="/tickets">{dataclose}</Link></div>
                      <div>Closed Tickets</div>                        
                    </h1>
                  </div>
              </div>
              <div className="column is-3">
                  <div className="box has-text-centered has-background-info	">
                    <h1 className="has-text-weight-bold has-text-white">
                      <div><Link className="has-text-white" to="/services">{datarepair}</Link></div>
                      <div>New Repair</div>                        
                    </h1>
                  </div>
              </div>
          </div>   
        </div>
        ):(
        <div className="container">
          <section className="section pt-1 pr-1 pl-1 pb-2">
              <Carousel autoPlay={true} 
                  infiniteLoop={true} 
                  interval={3000}
                  showThumbs={false} 
                  stopOnHover={true}>
                  {dataads.map((itemads) => (   
                  <div key={itemads.uuid}>
                      <figure className="image is-3by1">
                          <img src={itemads.url} />
                      </figure>
                  </div>
                  ))}
              </Carousel>
          </section> 

          <section className="section pt-1 pr-1 pl-1 pb-0">
            <h1 className="title has-text-centered">Our Products</h1>
            <form onSubmit={searchData}>
              <div className="field has-addons">
                <div className="control is-expanded">
                  <input
                    type="text"
                    className="input"
                    value={queryname}
                    onChange={(e) => setQueryName(e.target.value)}
                    placeholder="Search by product name..." />
                </div>
                <div className="control is-expanded">
                  <input
                    type="text"
                    className="input"
                    value={queryserial}
                    onChange={(e) => setQuerySerial(e.target.value)}
                    placeholder="Search by serial number..." />
                </div>
                <div className="control is-expanded">
                  <input
                    type="text"
                    className="input"
                    value={querymanu}
                    onChange={(e) => setQueryManu(e.target.value)}
                    placeholder="Search by merek..." />
                </div>
                <div className="control">
                  <button type="submit" className="button is-info">
                    Search
                  </button>
                </div>
              </div>
            </form> 
            <div className="columns mt-2">
                  {store.map((item) => (
                      <div key={item.uuid} className="column is-3">
                            <div className="card has-text-centered">
                                <div className="card-content">
                                    <figure className="image is-128x128 is-inline-block">
                                        <img src={item.url} alt="Image" />
                                    </figure>
                                    <p>{item.name.substring(0, 22)+"..."}</p>
                                    <p>Serial: {item.serialnumber}</p>
                                    <p>Rp. <NumericFormat
                                      value={item.price}
                                      displayType="text" // Renders as a <span> instead of an input
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true} /></p>
                                </div>
                            </div>
                      </div>
                  ))}
              </div>
              <p className="is-size-7">
                  Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
              </p>
              <p className="has-text-centered has-text-danger">{msg}</p>
              <nav
                  className="pagination is-centered is-size-7"
                  key={rows}
                  role="navigation"
                  aria-label="pagination"
              >
                  <ReactPaginate
                  breakLabel="..."
                  previousLabel={"< Prev"}
                  nextLabel={"Next >"}
                  pageCount={Math.min(10, pages)}
                  onPageChange={changePage}
                  containerClassName={"pagination-list"}
                  pageLinkClassName={"pagination-link"}
                  previousLinkClassName={"pagination-previous"}
                  nextLinkClassName={"pagination-next"}
                  activeLinkClassName={"pagination-link is-current"}
                  disabledLinkClassName={"pagination-link is-disabled"} />
            </nav>
          </section>       
        </div>
        )}         
      </div>
    </div>
  );
};

export default Welcome;
